/** Default rows per RDT list page (see spec FR-014, SC-005; mirrors frontend). */
export const DEFAULT_LIST_PAGE_SIZE = 10;
